import { DISPLAY_DATE_FORMAT } from "./constants";

export const CRM_TASK_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },

  {
    name: "name",
    title: "Opportunity Name",
    style: { fontWeight: 600 },
  },
  {
    name: "email_from",
    title: "Email",
  },
  {
    name: "city",
    title: "City",
  },
  // {
  //   name: "date_deadline",
  //   title: "Date",
  // },
  {
    name: "partner_id",
    title: "Customer",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
  {
    name: "stage_id",
    title: "Stage Name",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
  {
    name: "stage_id",
    title: "Stage Id",
    handleCell: (data, item) => data?.[item.name]?.[0] || "",
  },
];

export const ORDERS_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },
  {
    name: "name",
    title: "Order",
    style: { fontWeight: 600, cursor: "pointer" },
  },
  {
    name: "date_order",
    title: "Date",
    dateFormat: DISPLAY_DATE_FORMAT,
  },
  {
    name: "partner_id",
    title: "Customer",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
  {
    name: "state",
    title: "Payment Status",
    handleCell: (data, item) => (
      <span className="payment_div text-capitalize p-2 ">
        {data?.[item.name] || ""}
      </span>
    ),
  },
  {
    name: "amount_total",
    title: "Total",
  },
  {
    name: "user_id",
    title: "SalesPerson",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },

  {
    name: "invoice_status_label",
    title: "Invoice Status",
    handleCell: (data, item) => (
      <span className="status_div p-2">{data?.[item.name] || ""}</span>
    ),
    // handleCell:(data, item) => data[item.name][1],
  },
];

export const VTEX_PRODUCT_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },
  {
    name: "name",
    title: "Name",
    style: { fontWeight: 600 },
  },
  {
    name: "company_id",
    title: "Store Name",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
  {
    name: "barcode",
    title: "Barcode",
  },
  {
    name: "qty_available",
    title: "QTY",
  },
  {
    name: "cost_currency_id",
    title: "Sale Price",
    handleCell: (data, item) =>
      `${data?.list_price || 0} ${data?.[item.name]?.[1] || ""}`,
  },
];
export const PRODUCT_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },
  {
    name: "name",
    title: "Name",
    style: { fontWeight: 600 },
  },
  {
    name: "website_id",
    title: "Website",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
  {
    name: "barcode",
    title: "Barcode",
  },
  {
    name: "qty_available",
    title: "QTY",
  },
  {
    name: "cost_currency_id",
    title: "Sale Price",
    handleCell: (data, item) =>
      `${data?.list_price || 0} ${data?.[item.name]?.[1] || ""}`,
  },
];
export const BRANDS_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },
  {
    name: "name",
    title: "Brand Name",
    style: { fontWeight: 600 },
  },
];
export const ATTRIBUTES_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },
  {
    name: "name",
    title: "Attribute Name",
    // style: { fontWeight: 600 },
  },
  {
    name: "display_type",
    title: "Display Type",
    // style: { fontWeight: 600 },
  },
  {
    name: "create_variant",
    title: "Variants Creation Mode",
    // style: { fontWeight: 600 },
  },
];
export const CATEGORIES_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 50 },
  },
  {
    name: "display_name",
    title: "Category",
    style: { fontWeight: 600, maxWidth: 250 },
  },
  {
    name: "parent_id",
    title: "Parent Category",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
    style: { fontWeight: 600, minWidth: 150 },
  },
  {
    name: "vtex_commission",
    title: "Commission",
    style: { fontWeight: 600, maxWidth: 100 },
  },
  // {
  //   name: "tax_id",
  //   title: "Tax",
  //   handleCell: (data, item) => data?.[item.name]?.[1] || "",
  //   style: { fontWeight: 600, minWidth: 170 },
  // },
];

export const SUBSCRIPTION_LIST_TABLE_VIEW = [
  {
    name: "package_name",
    title: "Package",
    style: { fontWeight: 600 },
  },
  {
    name: "date_start",
    title: "Start Date",
    dateFormat: DISPLAY_DATE_FORMAT,
  },
  {
    name: "date_end",
    title: "End Date",
    dateFormat: DISPLAY_DATE_FORMAT,
  },
  {
    name: "state",
    title: "State",
    handleCell: (data, item) => (
      <span className="status_div">{data?.[item.name] || ""}</span>
    ),
  },
];

export const WAREHOUSE_LIST_TABLE_VIEW = [
  {
    name: "package_name",
    title: "Name",
    style: { fontWeight: 600 },
  },
  {
    name: "date_start",
    title: "Phone",
  },
  {
    name: "date_end",
    title: "Email",
    dateFormat: DISPLAY_DATE_FORMAT,
  },
  {
    name: "state",
    title: "SalesPerson",
    handleCell: (data, item) => (
      <span className="status_div">{data?.[item.name] || ""}</span>
    ),
  },
  {
    name: "state",
    title: "City",
    handleCell: (data, item) => (
      <span className="status_div">{data?.[item.name] || ""}</span>
    ),
  },
  {
    name: "state",
    title: "Country",
    handleCell: (data, item) => (
      <span className="status_div">{data?.[item.name] || ""}</span>
    ),
  },
  {
    name: "state",
    title: "Company",
    handleCell: (data, item) => (
      <span className="status_div">{data?.[item.name] || ""}</span>
    ),
  },
];

export const VTEX_MERCHANT_COMPANY_LIST_TABLE_VIEW = [
  {
    name: "name",
    title: "Store Name",
    style: { fontWeight: 600 },
  },
  {
    name: "partner_id",
    title: "Partner",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
];
export const COMPANY_LIST_TABLE_VIEW = [
  {
    name: "name",
    title: "Company Name",
    style: { fontWeight: 600 },
  },
  {
    name: "partner_id",
    title: "Partner",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
];
export const VTEX_COMPANY_LIST_TABLE_VIEW = [
  {
    name: "image_url",
    title: "Company Logo",
    handleCell: (data) => (
      <img
        src={`${window.location.protocol}//${window.location.host}${data.image_url}`}
        height={70}
        width={100}
        alt="Logo"
      />
    ),
  },
  {
    name: "name",
    title: "Store Name",
    style: { fontWeight: 600, verticalAlign: "middle" },
  },
  {
    name: "contract_status",
    title: "Contract Status",
    style: {
      fontWeight: 600,
      verticalAlign: "middle",
      textAlign: "center",
    },
    handleCell: (data) =>
      !data.contract_status ? (
        <span
          className="badge rounded-pill bg-success"
          style={{ fontSize: "14px" }}
        >
          Online
        </span>
      ) : (
        <span
          className={`badge rounded-pill bg-${
            data.contract_status.toLowerCase() === "pending"
              ? "warning"
              : data.contract_status.toLowerCase() === "approved"
              ? "success"
              : data.contract_status.toLowerCase() === "rejected"
              ? "danger"
              : ""
          }`}
          style={{ fontSize: "14px" }}
        >
          {`${data.contract_status}`}
        </span>
      ),
  },
  {
    name: "vtex_status",
    title: "VTEX Integration Status",
    style: {
      fontWeight: 600,
      verticalAlign: "middle",
      textAlign: "center",
    },
    handleCell: (data) =>
      !data.vtex_status ? (
        ""
      ) : (
        <span
          className={`badge rounded-pill bg-${
            data.vtex_status.toLowerCase() === "pending"
              ? "warning"
              : data.vtex_status.toLowerCase() === "approved"
              ? "success"
              : data.vtex_status.toLowerCase() === "rejected"
              ? "danger"
              : ""
          }`}
          style={{ fontSize: "14px" }}
        >
          {`${data.vtex_status}`}
        </span>
      ),
  },
  {
    name: "create_date",
    title: "Creation Date",
    dateFormat: DISPLAY_DATE_FORMAT,
    style: { verticalAlign: "middle" },
  },
];
export const VTEX_USERS_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },
  {
    name: "name",
    title: "Name",
    style: { fontWeight: 600 },
  },
  {
    name: "login",
    title: "Login",
  },
  {
    name: "company_id",
    title: "Store Name",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
];
export const USERS_LIST_TABLE_VIEW = [
  {
    name: "id",
    title: "id",
    isCheckbox: true,
    style: { minWidth: 100 },
  },
  {
    name: "name",
    title: "Name",
    style: { fontWeight: 600 },
  },
  {
    name: "login",
    title: "Login",
  },
  // {
  //   name: "login_date",
  //   title: "Authentication",
  //   dateFormat: DISPLAY_DATE_FORMAT,
  // },
  // {
  //   name: "lang",
  //   title: "Language",
  // },
  // {
  //   name: "",
  //   title: "Two Factor Authentication",
  // },
  {
    name: "company_id",
    title: "Company",
    handleCell: (data, item) => data?.[item.name]?.[1] || "",
  },
];
